
export default {
  data() {
    return {
      navListFull: [],
    }
  },
  computed: {
    navList() {
      return this.navListFull.filter(nav => nav.name !== '首页');
    }
  },
  async fetch() {
    try {
      this.navListFull = await this.$axios.$get('/channel/channelTree.do?sid=483');
    } catch (err) {
      console.log(err);
    }

  },
}
